import {
  addDays,
  addMonths,
  addQuarters,
  addWeeks,
  endOfDayUTC,
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  nextFriday,
  nextSaturday,
  nextSunday,
  previousFriday,
  previousSaturday,
  previousSunday,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
} from './date-util';

export const DATE_PRESETS = {
  LastFriday: startOfDay(previousFriday()),
  LastSaturday: startOfDay(previousSaturday()),
  LastSunday: startOfDay(previousSunday()),
  NextFriday: startOfDay(nextFriday()),
  NextSaturday: startOfDay(nextSaturday()),
  NextSunday: startOfDay(nextSunday()),
  Today: startOfDay(new Date()),
  Tomorrow: addDays(startOfDay(new Date()), 1),
  Yesterday: addDays(startOfDay(new Date()), -1),
};

export const DATE_RANGES = {
  Upcomming: {
    end: null,
    start: startOfDay(new Date()),
  },
  Last7Days: {
    end: endOfDayUTC(addDays(new Date(), -1)),
    start: startOfDay(addDays(new Date(), -7)),
  },
  Last30Days: {
    end: endOfDayUTC(addDays(new Date(), -1)),
    start: startOfDay(addDays(new Date(), -30)),
  },
  Last90Days: {
    end: endOfDayUTC(addDays(new Date(), -1)),
    start: startOfDay(addDays(new Date(), -90)),
  },
  LastMonth: {
    end: endOfMonth(addMonths(new Date(), -1)),
    start: startOfMonth(addMonths(new Date(), -1)),
  },
  LastQuarter: {
    end: endOfQuarter(addQuarters(new Date(), -1)),
    start: startOfQuarter(addQuarters(new Date(), -1)),
  },
  LastWeek: {
    end: endOfWeek(addWeeks(new Date(), -1)),
    start: startOfWeek(addWeeks(new Date(), -1)),
  },
  MonthToDate: {
    end: endOfDayUTC(new Date()),
    start: startOfMonth(new Date()),
  },
  QuarterToDate: {
    end: endOfDayUTC(new Date()),
    start: startOfQuarter(new Date()),
  },
  ThisWeek: {
    end: endOfWeek(new Date()),
    start: startOfWeek(new Date()),
  },
  Today: { end: endOfDayUTC(new Date()), start: startOfDay(new Date()) },
  Yesterday: {
    end: endOfDayUTC(addDays(new Date(), -1)),
    start: startOfDay(addDays(new Date(), -1)),
  },
};
